const placeholderImage = '/place_thumb_placeholder.png'

export default placeholderImage
